var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: {
            "default-active": _vm.$route.path,
            mode: "horizontal",
            "background-color": "#545c64",
            "text-color": "#fff",
            "active-text-color": "#409EFF",
            router: ""
          }
        },
        [
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/wavepickinglist" } },
            [_vm._v("波次单列表")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/aswavepicking/aswavepickinglist" } },
            [_vm._v("售后波次")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/TempSummaryList/5" } },
            [_vm._v("质检汇总")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/TempSummaryList/6" } },
            [_vm._v("改标汇总")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            {
              attrs: { index: "/home/surpassSummary/surpassSummaryPickingList" }
            },
            [_vm._v("中分汇总拣货")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "120px" },
                                        attrs: { placeholder: "波次号" },
                                        on: { change: _vm.search_type_change },
                                        model: {
                                          value: _vm.search_type,
                                          callback: function($$v) {
                                            _vm.search_type = $$v
                                          },
                                          expression: "search_type"
                                        }
                                      },
                                      _vm._l(_vm.search_options, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { staticStyle: { "margin-left": "-15px" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "195px" },
                                      attrs: { placeholder: "请输入搜索内容" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.search_value,
                                        callback: function($$v) {
                                          _vm.search_value = $$v
                                        },
                                        expression: "search_value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "请选择状态" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      _vm._l(_vm.conditionData.status, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.status_id,
                                          attrs: {
                                            label: item.status_name,
                                            value: item.status_id
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: {
                                          placeholder: "请选择波次类型"
                                        },
                                        model: {
                                          value: _vm.form.type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "type", $$v)
                                          },
                                          expression: "form.type"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.conditionData.type, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.type_id,
                                            attrs: {
                                              label: item.type_name,
                                              value: item.type_id
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: {
                                          placeholder: "波次拣货属性",
                                          multiple: ""
                                        },
                                        model: {
                                          value: _vm.form.picking_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "picking_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.picking_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: "0", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.picking_type,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.type_id,
                                              attrs: {
                                                label: item.type_name,
                                                value: item.type_id
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: {
                                          placeholder: "是否生成拣货任务"
                                        },
                                        model: {
                                          value:
                                            _vm.form.is_generate_picking_task,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_generate_picking_task",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.is_generate_picking_task"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData
                                            .generate_picking_task,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.value,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "波次时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "350px" },
                                      attrs: {
                                        "default-time": [
                                          "06:00:00",
                                          "06:00:00"
                                        ],
                                        type: "datetimerange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "面单状态" },
                                        model: {
                                          value: _vm.form.print_status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "print_status",
                                              $$v
                                            )
                                          },
                                          expression: "form.print_status"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.print_status,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.name,
                                                value: item.id
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "是否优质用户订单" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "是否优质用户订单"
                                        },
                                        model: {
                                          value: _vm.form.is_prior,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_prior", $$v)
                                          },
                                          expression: "form.is_prior"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "是", value: "1" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "否", value: "2" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          "background-color": "#e1e1e1"
                                        },
                                        on: { click: _vm.resetCondition }
                                      },
                                      [_vm._v("重置")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    查询波次\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.dialogFormUserVisible = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "按用户ID筛选波次（数量：" +
                                            _vm._s(_vm.userSearchCount) +
                                            "）"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dialog",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.loading,
                                        expression: "loading"
                                      }
                                    ],
                                    attrs: {
                                      title:
                                        "当前录入用户ID数量：" +
                                        _vm.userSearchCount +
                                        "（多个用户ID以换行方式隔开，单次最多1000个）",
                                      visible: _vm.dialogFormUserVisible
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.dialogFormUserVisible = $event
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form",
                                      { attrs: { model: _vm.form } },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                autosize: {
                                                  minRows: 5,
                                                  maxRows: 10
                                                },
                                                placeholder: "请输入内容"
                                              },
                                              model: {
                                                value: _vm.form.user_search,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "user_search",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.user_search"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dialog-footer",
                                        attrs: { slot: "footer" },
                                        slot: "footer"
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            on: { click: _vm.userSearchCancel }
                                          },
                                          [_vm._v("取 消")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                _vm.dialogFormUserVisible = false
                                              }
                                            }
                                          },
                                          [_vm._v("确 定")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: {
                                          click: function($event) {
                                            _vm.show_statistics = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    统计数据查看\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.is_show_search_option = !_vm.is_show_search_option
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.is_show_search_option
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "配齐状态"
                                                },
                                                model: {
                                                  value: _vm.form.full_allot,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "full_allot",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.full_allot"
                                                }
                                              },
                                              _vm._l(_vm.is_pq, function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.key
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "支付方式"
                                                },
                                                model: {
                                                  value: _vm.form.pay,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pay",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.pay"
                                                }
                                              },
                                              _vm._l(_vm.payData, function(
                                                item
                                              ) {
                                                return _c("el-option", {
                                                  key: item.pay_id,
                                                  attrs: {
                                                    label: item.pay_name,
                                                    value: item.pay_id
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  multiple: "",
                                                  placeholder: "请选择有无备注"
                                                },
                                                model: {
                                                  value: _vm.form.is_remark,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "is_remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.is_remark"
                                                }
                                              },
                                              _vm._l(
                                                _vm.noteWithoutNumData,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.note_id,
                                                    attrs: {
                                                      label: item.note_name,
                                                      value: item.note_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        (_vm.form.is_remark || []).some(
                                          function(item) {
                                            return [1, 2].includes(item)
                                          }
                                        )
                                          ? _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "150px"
                                                    },
                                                    attrs: {
                                                      placeholder: "备注类型"
                                                    },
                                                    model: {
                                                      value: _vm.form.note_type,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "note_type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.note_type"
                                                    }
                                                  },
                                                  _vm._l(_vm.noteData, function(
                                                    item
                                                  ) {
                                                    return _c("el-option", {
                                                      key: item.note_id,
                                                      attrs: {
                                                        label: item.note_name,
                                                        value: item.note_id
                                                      }
                                                    })
                                                  }),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "选择快递公司"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.shipping_company,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "shipping_company",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.shipping_company"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.express,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: item,
                                                      value: item
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "是否囤货"
                                                },
                                                model: {
                                                  value: _vm.form.is_stock,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "is_stock",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.is_stock"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData.is_stock,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "是否拦截"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.is_stop_shipping,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "is_stop_shipping",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.is_stop_shipping"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData
                                                    .is_stop_shipping,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "波次待发数量" } },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                placeholder: "波次待发数量"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form.wave_picking_num,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "wave_picking_num",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.wave_picking_num"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "~" } },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                placeholder: "波次待发数量"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form.wave_picking_num_end,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "wave_picking_num_end",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.wave_picking_num_end"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "订单时间：" } },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                "default-time": [
                                                  "06:00:00",
                                                  "06:00:00"
                                                ],
                                                type: "datetimerange",
                                                "range-separator": "至",
                                                "start-placeholder": "开始日期",
                                                "end-placeholder": "结束日期"
                                              },
                                              model: {
                                                value: _vm.form.order_time,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "order_time",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.order_time"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "省"
                                                },
                                                on: { change: _vm.getCity },
                                                model: {
                                                  value: _vm.form.province,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "province",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.province"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.province,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.region_id,
                                                    attrs: {
                                                      label: item.region_name,
                                                      value: item.region_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "市"
                                                },
                                                on: { change: _vm.getDistrict },
                                                model: {
                                                  value: _vm.form.city,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "city",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.city"
                                                }
                                              },
                                              _vm._l(
                                                _vm.cityData.list,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.region_id,
                                                    attrs: {
                                                      label: item.region_name,
                                                      value: item.region_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "区"
                                                },
                                                model: {
                                                  value: _vm.form.district,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "district",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.district"
                                                }
                                              },
                                              _vm._l(
                                                _vm.districtData.list,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.region_id,
                                                    attrs: {
                                                      label: item.region_name,
                                                      value: item.region_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "除去市场"
                                                },
                                                model: {
                                                  value: _vm.form.market_id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "market_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.market_id"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.market,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.key,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.key
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "商品一级分类"
                                                },
                                                model: {
                                                  value: _vm.form.cat_ids,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "cat_ids",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.cat_ids"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.category,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.cat_id,
                                                    attrs: {
                                                      label: item.cat_name,
                                                      value: item.cat_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "是否即日发"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.same_day_shipping,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "same_day_shipping",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.same_day_shipping"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData
                                                    .same_day_shipping,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "是否有现货订单"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.has_spot_order,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "has_spot_order",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.has_spot_order"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData
                                                    .has_spot_order,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "用户层级标签" } },
                                          [
                                            _c("el-cascader", {
                                              attrs: {
                                                options:
                                                  _vm.conditionData.two_type,
                                                props: { multiple: true },
                                                filterable: ""
                                              },
                                              on: { change: _vm.changeTwoType },
                                              model: {
                                                value: _vm.twoType,
                                                callback: function($$v) {
                                                  _vm.twoType = $$v
                                                },
                                                expression: "twoType"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "用户净值标签" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder:
                                                    "请选择用户净值标签",
                                                  multiple: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .user_net_worth_type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "user_net_worth_type",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.user_net_worth_type"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData
                                                    .user_net_worth_type,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.value,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "出库时间：" } },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                "default-time": [
                                                  "06:00:00",
                                                  "06:00:00"
                                                ],
                                                type: "datetimerange",
                                                "range-separator": "至",
                                                "start-placeholder": "开始日期",
                                                "end-placeholder": "结束日期"
                                              },
                                              model: {
                                                value: _vm.form.out_time,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "out_time",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.out_time"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "仓库备注类型"
                                                },
                                                model: {
                                                  value: _vm.form.remark_type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "remark_type",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.remark_type"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "",
                                                    label: "全部"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "1",
                                                    label: "快递分配失败"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-cascader", {
                                              attrs: {
                                                placeholder: "选择中分位",
                                                props: _vm.hgCodeByHgProps
                                              },
                                              model: {
                                                value: _vm.form.hgd_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "hgd_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.hgd_id"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "发货波次单筛选"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.is_today_shipments,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "is_today_shipments",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.is_today_shipments"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "0",
                                                    label: "全部"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "1",
                                                    label: "今日可发"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-option", {
                                                  attrs: {
                                                    value: "2",
                                                    label: "次日可发"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _vm.resData
                          ? _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-dropdown",
                                      {
                                        attrs: {
                                          "split-button": "",
                                          type: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.lockWavePicking(0)
                                          },
                                          command: _vm.lockWavePicking
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  锁定波次\n                  "
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              { attrs: { command: "1" } },
                                              [_vm._v("全部锁定波次")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger" },
                                        on: { click: _vm.generateTaskBefore }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  生成拣货任务\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        staticStyle: { margin: "0 10px 2px" },
                                        attrs: {
                                          action: _vm.action1,
                                          name: "excel",
                                          limit: 1,
                                          "on-success": _vm.importFileWeight,
                                          "file-list": _vm.fileList,
                                          "auto-upload": "",
                                          "with-credentials": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          { attrs: { type: "primary" } },
                                          [_vm._v("导入重量")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.dialogFormVisible = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导入快递单\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dialog",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.loading,
                                        expression: "loading"
                                      }
                                    ],
                                    attrs: {
                                      title: "请先选择快递公司",
                                      visible: _vm.dialogFormVisible
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.dialogFormVisible = $event
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form",
                                      { attrs: { model: _vm.form } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "快递公司" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  placeholder: "请选择快递公司"
                                                },
                                                model: {
                                                  value: _vm.form.express,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "express",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.express"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.express,
                                                function(express) {
                                                  return _c("el-option", {
                                                    key: express,
                                                    attrs: {
                                                      label: express,
                                                      value: express
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "导入快递单" } },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                ref: "upload",
                                                attrs: {
                                                  action: _vm.action2,
                                                  name: "excel",
                                                  limit: 1,
                                                  "on-success":
                                                    _vm.importFileExpress,
                                                  "file-list": _vm.fileList,
                                                  "auto-upload": true,
                                                  "with-credentials": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      slot: "trigger",
                                                      size: "mini",
                                                      type: "primary"
                                                    },
                                                    slot: "trigger"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        选择文件\n                      "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dialog-footer",
                                        attrs: { slot: "footer" },
                                        slot: "footer"
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.dialogFormVisible = false
                                              }
                                            }
                                          },
                                          [_vm._v("取 消")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: { click: _vm.importExpress }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    确 定\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.output }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导出波次单\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.outputInfo }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导出波次单明细\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.exportExpress }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导出电子面单\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.outputExpress }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  物流数据导出\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.outputLog }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导出改排日志\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "-18px" },
                                        attrs: { type: "success" },
                                        on: {
                                          click: function($event) {
                                            _vm.show_log_time = !_vm.show_log_time
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "el-icon-date" })]
                                    ),
                                    _vm._v(" "),
                                    _vm.show_log_time == 1
                                      ? _c("el-date-picker", {
                                          attrs: {
                                            format: "yyyy-MM-dd HH:mm:ss",
                                            type: "datetimerange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期",
                                            "default-time": [
                                              "06:00:00",
                                              "06:00:00"
                                            ]
                                          },
                                          model: {
                                            value: _vm.form.log_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "log_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.log_time"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.outputLabel }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导出改标用户波次明细\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "-18px" },
                                        attrs: { type: "success" },
                                        on: {
                                          click: function($event) {
                                            _vm.show_label_time = !_vm.show_label_time
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "el-icon-date" })]
                                    ),
                                    _vm._v(" "),
                                    _vm.show_label_time == 1
                                      ? _c("el-date-picker", {
                                          attrs: {
                                            format: "yyyy-MM-dd HH:mm:ss",
                                            type: "datetimerange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.label_time,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "label_time",
                                                $$v
                                              )
                                            },
                                            expression: "form.label_time"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.outputReAllotLog }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  改排重配明细导出\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "-18px" },
                                        attrs: { type: "success" },
                                        on: {
                                          click: function($event) {
                                            _vm.show_gp_time = !_vm.show_gp_time
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "el-icon-date" })]
                                    ),
                                    _vm._v(" "),
                                    _vm.show_gp_time == 1
                                      ? _c("el-date-picker", {
                                          attrs: {
                                            format: "yyyy-MM-dd HH:mm:ss",
                                            type: "datetimerange",
                                            "range-separator": "至",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期"
                                          },
                                          model: {
                                            value: _vm.form.gp_time,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "gp_time", $$v)
                                            },
                                            expression: "form.gp_time"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "infor" },
                                        on: { click: _vm.exlceImprot }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导入批量修改波次\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          action: _vm.action3,
                                          name: "excel",
                                          limit: 1,
                                          "on-success": _vm.importFileWeight,
                                          "file-list": _vm.fileList,
                                          "auto-upload": "",
                                          "with-credentials": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          { attrs: { type: "primary" } },
                                          [_vm._v("导入物流信息")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "第一行表头,A列波次号,B列订单号,C列SKU,D列备注,E列一级原因,F列二级原因",
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            attrs: {
                                              action: _vm.action4,
                                              name: "file",
                                              limit: 1,
                                              "on-success": _vm.importFileSpot,
                                              "file-list": _vm.fileList,
                                              "auto-upload": "",
                                              "with-credentials": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              { attrs: { type: "primary" } },
                                              [_vm._v("导入不赔商品原因")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.handleBatchRecheck }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  批量重新校验\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.express100FormVisible = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  导入波次重跑快递优选\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dialog",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.loading,
                                        expression: "loading"
                                      }
                                    ],
                                    attrs: {
                                      title: "导入波次重跑快递优选",
                                      visible: _vm.express100FormVisible
                                    },
                                    on: {
                                      "update:visible": function($event) {
                                        _vm.express100FormVisible = $event
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "根据所提供的的波次单号,重跑快递优选给出最新的快递公司。此操作不影响波次其他状态。单次最多2000个波次单。"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-form",
                                      { attrs: { model: _vm.form } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "" } },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                ref: "upload",
                                                attrs: {
                                                  action: _vm.action2,
                                                  name: "excel",
                                                  limit: 1,
                                                  "on-success":
                                                    _vm.importFileExpress100,
                                                  "file-list": _vm.fileList,
                                                  "auto-upload": true,
                                                  "with-credentials": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      slot: "trigger",
                                                      size: "mini",
                                                      type: "primary"
                                                    },
                                                    slot: "trigger"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        选择文件\n                      "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { size: "mini" },
                                                on: {
                                                  click:
                                                    _vm.exportExpress100Task
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      导出文件模版\n                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dialog-footer",
                                        attrs: { slot: "footer" },
                                        slot: "footer"
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.express100FormVisible = false
                                              }
                                            }
                                          },
                                          [_vm._v("取 消")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: _vm.importExpress100Task
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    提 交\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    "min-height": "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [
                    _vm._v(
                      "\n              波次单数量：" +
                        _vm._s(_vm.resData.total) +
                        "\n                  波次商品待发数量：" +
                        _vm._s(_vm.resData.sku_num) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        flex: "1",
                        "flex-flow": "row wrap",
                        "align-items": "center",
                        "justify-content": "right"
                      }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: {
                            "margin-right": "8px",
                            "padding-bottom": "2px"
                          },
                          attrs: {
                            action: _vm.action5,
                            name: "excel",
                            limit: 1,
                            "on-success": _vm.importOrderDelivery,
                            "file-list": _vm.fileList,
                            "show-file-list": false,
                            "auto-upload": "",
                            "with-credentials": ""
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { type: "primary", size: "mini" } },
                            [_vm._v("订单导入发货")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.isShowDialogTailOrder = true
                            }
                          }
                        },
                        [_vm._v("\n            尾货折销导入发货\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { type: "info", size: "mini" },
                          on: { click: _vm.handlePrintExpressOrderDialogOpen }
                        },
                        [_vm._v("\n            快速重打面单\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            title: "快速重打面单",
                            visible: _vm.printExpressOrder
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.printExpressOrder = $event
                            }
                          }
                        },
                        [
                          _c(
                            "el-form",
                            { attrs: { model: _vm.form } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "请输入波次单" } },
                                [
                                  _c("el-input", {
                                    ref: "wave_picking_no",
                                    attrs: { placeholder: "请输入波次单" },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.rePrintExpressOrder.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.wave_picking_no,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "wave_picking_no",
                                          $$v
                                        )
                                      },
                                      expression: "form.wave_picking_no"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "快麦唯一识别码" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "快麦唯一识别码" },
                                    on: { blur: _vm.handleUniqueCodeBlur },
                                    model: {
                                      value: _vm.form.unique_code,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "unique_code", $$v)
                                      },
                                      expression: "form.unique_code"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.show_all_time == 1
                        ? _c("el-date-picker", {
                            staticStyle: { "margin-right": "-30px" },
                            attrs: {
                              size: "mini",
                              format: "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "default-time": ["06:00:00", "06:00:00"]
                            },
                            model: {
                              value: _vm.form.all_time,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "all_time", $$v)
                              },
                              expression: "form.all_time"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "-15px" },
                          attrs: { type: "info", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.show_all_time = !_vm.show_all_time
                            }
                          }
                        },
                        [_c("i", { staticClass: "el-icon-date" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info", size: "mini" },
                          on: { click: _vm.outputall }
                        },
                        [_vm._v("\n            导出全部波次单\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "mini" },
                          on: { click: _vm.mergeWavePickingBatch }
                        },
                        [_vm._v("\n            一键合并波次")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "mini" },
                          on: { click: _vm.unlockWavePickingByIds }
                        },
                        [_vm._v("\n            批量解锁")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "mini" },
                          on: { click: _vm.mergeWavePicking }
                        },
                        [_vm._v("\n            合并波次\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "mini" },
                          on: { click: _vm.waybillDiscard }
                        },
                        [_vm._v("\n            取消面单\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "mini" },
                          on: { click: _vm.printWavePicking }
                        },
                        [_vm._v("\n            打印配货单\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.printWayBill }
                        },
                        [_vm._v("\n            批量打印面单\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { type: "success", size: "mini" },
                          on: { click: _vm.stockWpOutPicking }
                        },
                        [_vm._v("\n            囤货波次出库拣货\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { type: "success", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.shippingVisible = true
                            }
                          }
                        },
                        [_vm._v("修改快递公司")]
                      ),
                      _vm._v(" "),
                      _c("field-setting", {
                        attrs: { page: "1" },
                        on: { onsuccess: _vm.changeFields }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.resData.data
                ? _c(
                    "div",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "600",
                            data: _vm.resData.data,
                            "tooltip-effect": "dark",
                            "row-class-name": _vm.tableRowClassName
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              type: "selection",
                              width: "55"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wave_picking_no",
                              label: "波次号",
                              width: "120",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sender_type",
                              label: "寄件人信息",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showFields.user_id
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "user_id",
                                  label: "用户ID",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.consignee
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "consignee",
                                  label: "收货人姓名",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_full_allot
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_full_allot",
                                  label: "是否配齐",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wave_picking_type",
                              label: "波次类型",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "quality_level",
                              label: "质检标准",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "hg_code",
                              label: "中分位",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wave_picking_status",
                              label: "状态",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_is_generate_picking_task
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_is_generate_picking_task",
                                  label: "是否生成拣货任务",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_mobile_hide
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_mobile_hide",
                                  label: "收货人手机",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.address
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "address",
                                  label: "收货人地址",
                                  "show-overflow-tooltip": "",
                                  align: "left",
                                  width: "200"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.beforeChangeAddress(
                                                  scope.row
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.address))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  535807420
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipping_company
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_company",
                                  label: "快递公司",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.guarantee_value_formal
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "guarantee_value_formal",
                                  label: "是否保价",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sender",
                              label: "网点",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shipping_type_formal",
                              label: "快递公司分配方式",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_is_put_picking_list
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_is_put_picking_list",
                                  label: "是否放置配货单",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.updateFields(
                                                  scope.row,
                                                  "PutList"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row
                                                  .wave_picking_is_put_picking_list
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2884902639
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.is_delivery_formal
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "is_delivery_formal",
                                  label: "是否催发",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.custom_note
                            ? _c("el-table-column", {
                                key: "custom_note",
                                attrs: {
                                  prop: "custom_note",
                                  label: "用户备注",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._l(
                                            scope.row.custom_note,
                                            function(custom_value, custom_key) {
                                              return [
                                                custom_value
                                                  ? _c(
                                                      "span",
                                                      { key: custom_key },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              custom_key + 1
                                                            ) +
                                                            "." +
                                                            _vm._s(
                                                              custom_value
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                        _c("br")
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3036815100
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.admin_note
                            ? _c("el-table-column", {
                                key: "admin_note",
                                attrs: {
                                  prop: "admin_note",
                                  label: "客服备注",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._l(scope.row.admin_note, function(
                                            admin_value,
                                            admin_key
                                          ) {
                                            return [
                                              admin_value
                                                ? _c(
                                                    "span",
                                                    { key: admin_key },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            admin_key + 1
                                                          ) +
                                                          "." +
                                                          _vm._s(admin_value)
                                                      ),
                                                      _c("br")
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1301686521
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.ck_remark
                            ? _c("el-table-column", {
                                key: "ck_remark",
                                attrs: {
                                  prop: "ck_remark",
                                  label: "仓库备注",
                                  width: "100",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.seCkRemark(scope.row)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.ck_remark))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2303366602
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_picking_type
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_picking_type",
                                  label: "拣货属性",
                                  width: "200",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.updateFields(
                                                  scope.row,
                                                  "PickingType"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row
                                                  .wave_picking_picking_type
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1546680708
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipping_num
                            ? _c("el-table-column", {
                                key: "shipping_num",
                                attrs: {
                                  prop: "shipping_num",
                                  label: "快递单号",
                                  "show-overflow-tooltip": "",
                                  align: "center",
                                  width: "200"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.beforeChangeShipping(
                                                  scope.row
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.shipping_num)
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2062304021
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_num
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_num",
                                  label: "待发货商品数量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.pre_weight
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "pre_weight",
                                  label: "计算重量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.weight
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "weight",
                                  label: "实际(结算)重量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_print_status
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_print_status",
                                  label: "面单状态",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_pay_way
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_pay_way",
                                  label: "支付方式",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.order_sn
                            ? _c("el-table-column", {
                                key: "order_sn",
                                attrs: {
                                  prop: "order_sn",
                                  label: "订单号",
                                  width: "180",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._l(scope.row.order_sn, function(
                                            order_value,
                                            order_key
                                          ) {
                                            return [
                                              order_value
                                                ? _c(
                                                    "a",
                                                    {
                                                      key: order_key,
                                                      staticClass:
                                                        "_order_sn_item",
                                                      class: {
                                                        _order_sn_item_color:
                                                          _vm.resData.wait_allot_order_sn.indexOf(
                                                            order_value
                                                          ) === -1
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.getOrderId(
                                                            order_value
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            order_key + 1
                                                          ) +
                                                          "." +
                                                          _vm._s(order_value) +
                                                          "\n                  "
                                                      ),
                                                      _vm.resData.spot_order_sn[
                                                        scope.row
                                                          .wave_picking_id
                                                      ] &&
                                                      _vm.resData.spot_order_sn[
                                                        scope.row
                                                          .wave_picking_id
                                                      ].indexOf(order_value) !==
                                                        -1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "spot_order"
                                                            },
                                                            [_vm._v("现")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.resData
                                                        .prior_order_sn[
                                                        scope.row
                                                          .wave_picking_id
                                                      ] &&
                                                      _vm.resData.prior_order_sn[
                                                        scope.row
                                                          .wave_picking_id
                                                      ].indexOf(order_value) !==
                                                        -1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "spot_order yellow"
                                                            },
                                                            [_vm._v("优")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("br")
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4165061093
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.create_time
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "create_time",
                                  label: "波次生成时间",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipments_date
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "shipments_date",
                                  label: "预计发货日期",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_is_stop_shipping
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_is_stop_shipping",
                                  label: "是否拦截",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.update_time
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "update_time",
                                  label: "更新时间",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.sk_time
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "sk_time",
                                  label: "最近物流时间",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.sk_content
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "sk_content",
                                  label: "最近物流信息",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipping_kdniao_state
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_kdniao_state",
                                  label: "物流状态",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_is_stock
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_is_stock",
                                  label: "是否囤货",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_ext_same_day_shipping
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_ext_same_day_shipping",
                                  label: "是否即日发",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              fixed: "right",
                              label: "操作",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleClick(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v("查看")]
                                      ),
                                      scope.row.status == 4 &&
                                      scope.row.print_status != 1
                                        ? _c("br")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 4 &&
                                      scope.row.print_status != 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.reCheck(scope.row)
                                                }
                                              }
                                            },
                                            [_vm._v("重新校验")]
                                          )
                                        : _vm._e(),
                                      scope.row.print_status == 1 ||
                                      scope.row.print_status == 6
                                        ? _c("br")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.print_status == 1
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#67c23a" },
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.rePrint(scope.row)
                                                }
                                              }
                                            },
                                            [_vm._v("打印面单")]
                                          )
                                        : _vm._e(),
                                      _c("br"),
                                      _vm._v(" "),
                                      scope.row.status === "5"
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#67c23a" },
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.printNew(scope.row)
                                                }
                                              }
                                            },
                                            [_vm._v("打印新面单")]
                                          )
                                        : _vm._e(),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "red" },
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.beforeSplit(
                                                scope.row.wave_picking_id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("拆分波次")]
                                      ),
                                      scope.row.wave_picking_summary_id != 0
                                        ? _c("br")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.wave_picking_summary_id != 0
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "orange" },
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.unLockWavePicking(
                                                    scope.row.wave_picking_id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("解锁")]
                                          )
                                        : _vm._e(),
                                      _c("br"),
                                      _vm._v(" "),
                                      scope.row.is_stock == 1
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "gray"
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setStock(
                                                        scope.row
                                                          .wave_picking_id,
                                                        2,
                                                        scope.$index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("解除囤货")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.is_stock == 2
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "gray"
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setStock(
                                                        scope.row
                                                          .wave_picking_id,
                                                        1,
                                                        scope.$index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("标记囤货")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.is_stop_shipping == 2
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStop(
                                                        scope.row
                                                          .wave_picking_id,
                                                        1,
                                                        scope.$index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("拦截")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.is_stop_shipping == 1
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStop(
                                                        scope.row
                                                          .wave_picking_id,
                                                        2,
                                                        scope.$index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("取消拦截")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.dbid && scope.row.status < 4
                                        ? _c("br")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.form.dbid && scope.row.status < 4
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.wavePickingRearrange(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("改排")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2471036736
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right", padding: "25px" } },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.curPage,
                          background: "",
                          layout: "total, prev, pager, next, jumper ,sizes",
                          total: _vm.resData.total,
                          "page-size": _vm.form.pagesize,
                          "page-sizes": [50, 100, 200, 500]
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.curPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.curPage = $event
                          },
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "请选择快递公司",
                    visible: _vm.shippingVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.shippingVisible = $event
                    },
                    close: _vm.handleShippingDialogClose
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "快递公司" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择快递公司" },
                              on: { change: _vm.getSenders },
                              model: {
                                value: _vm.form.express,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "express", $$v)
                                },
                                expression: "form.express"
                              }
                            },
                            _vm._l(_vm.conditionData.express, function(
                              express
                            ) {
                              return _c("el-option", {
                                key: express,
                                attrs: { label: express, value: express }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.express !== "物流"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "网点" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择网点" },
                                  model: {
                                    value: _vm.form.sender_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sender_id", $$v)
                                    },
                                    expression: "form.sender_id"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "无", value: "0" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.senders, function(item) {
                                    return _c("el-option", {
                                      key: item.sender_id,
                                      attrs: {
                                        label: item.sender,
                                        value: item.sender_id
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.express === "物流"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "物流公司" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择网点" },
                                  model: {
                                    value: _vm.form.logistics_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "logistics_id", $$v)
                                    },
                                    expression: "form.logistics_id"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "无", value: "0" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.conditionData.logistics, function(
                                    item
                                  ) {
                                    return _c("el-option", {
                                      key: item.logistics_id,
                                      attrs: {
                                        label: item.logistics_name,
                                        value: item.logistics_id
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新数据范围" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "更新数据范围" },
                              model: {
                                value: _vm.form.update_shipping_type,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "update_shipping_type",
                                    $$v
                                  )
                                },
                                expression: "form.update_shipping_type"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "选择的波次修改", value: "0" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "按查询条件修改", value: "1" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footeidr",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.shippingVisible = false
                              _vm.senders = []
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.updateShipping(0)
                            }
                          }
                        },
                        [_vm._v("\n            确 定\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "输入修改地址",
                    visible: _vm.changeAddressVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.changeAddressVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "收件人" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_consignee,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "change_consignee", $$v)
                              },
                              expression: "form.change_consignee"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "手机" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_wave_picking_mobile_hide,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "change_wave_picking_mobile_hide",
                                  $$v
                                )
                              },
                              expression: "form.change_wave_picking_mobile_hide"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "省" },
                              on: { change: _vm.getCity },
                              model: {
                                value: _vm.form.change_province,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "change_province", $$v)
                                },
                                expression: "form.change_province"
                              }
                            },
                            _vm._l(_vm.conditionData.province, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "市" },
                              on: { change: _vm.getDistrict },
                              model: {
                                value: _vm.form.change_city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "change_city", $$v)
                                },
                                expression: "form.change_city"
                              }
                            },
                            _vm._l(_vm.cityData.list, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "区" },
                              model: {
                                value: _vm.form.change_district,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "change_district", $$v)
                                },
                                expression: "form.change_district"
                              }
                            },
                            _vm._l(_vm.districtData.list, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "详细地址" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_address,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "change_address", $$v)
                              },
                              expression: "form.change_address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "left" },
                          attrs: { type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.recoveryConsignee(1)
                            }
                          }
                        },
                        [_vm._v("恢复至下单的收件信息")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.changeAddressVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.changeAddress }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "改排最多件",
                    visible: _vm.delVisible,
                    width: "30%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.delVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "改排", prop: "delNum" } },
                        [
                          _c("el-input", {
                            attrs: { type: "number", max: _vm.skuNum },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      " 件,最多" + _vm._s(_vm.skuNum) + "件 "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ]),
                            model: {
                              value: _vm.form.delNum,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "delNum", $$v)
                              },
                              expression: "form.delNum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.delVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.doRearrange()
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "选择要拆分的订单",
                    visible: _vm.splitVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.splitVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择要拆分的订单" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.form.split_orders,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "split_orders", $$v)
                                },
                                expression: "form.split_orders"
                              }
                            },
                            _vm._l(_vm.orders, function(order) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: order.order_id,
                                  attrs: { label: order.order_id }
                                },
                                [_vm._v(_vm._s(order.order_sn))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.splitVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.doSplit }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { title: "备注", visible: _vm.ckRemarkVisible },
                  on: {
                    "update:visible": function($event) {
                      _vm.ckRemarkVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "备注" },
                            model: {
                              value: _vm.form.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.ckRemarkVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.doRemark }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "修改快递信息",
                    visible: _vm.changeShippingVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.changeShippingVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "快递公司" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择快递公司" },
                              model: {
                                value: _vm.form.change_shipping_company,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "change_shipping_company",
                                    $$v
                                  )
                                },
                                expression: "form.change_shipping_company"
                              }
                            },
                            _vm._l(_vm.conditionData.all_express, function(
                              express
                            ) {
                              return _c("el-option", {
                                key: express,
                                attrs: { label: express, value: express }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "快递单号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px", margin: "0" },
                            attrs: { placeholder: "快递单号" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_shipping_num,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "change_shipping_num", $$v)
                              },
                              expression: "form.change_shipping_num"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.changeShippingVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.changeShipping }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.show_statistics
        ? _c(
            "div",
            [
              _c("statistics", {
                on: {
                  onCloseDialog: function($event) {
                    _vm.show_statistics = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "囤货设置",
            visible: _vm.keepStock.isShow,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.keepStock, "isShow", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "到日期发货" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "picker-options": {
                        disabledDate: function(time) {
                          return (
                            time.getTime() + 24 * 60 * 60 * 1000 < Date.now()
                          )
                        }
                      },
                      clearable: true
                    },
                    model: {
                      value: _vm.keepStock.form.limit_ship_date,
                      callback: function($$v) {
                        _vm.$set(_vm.keepStock.form, "limit_ship_date", $$v)
                      },
                      expression: "keepStock.form.limit_ship_date"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "配齐数量发货" } },
                [
                  _c("el-input-number", {
                    attrs: { controls: false, type: "number", min: 0 },
                    model: {
                      value: _vm.keepStock.form.limit_ship_num,
                      callback: function($$v) {
                        _vm.$set(_vm.keepStock.form, "limit_ship_num", $$v)
                      },
                      expression: "keepStock.form.limit_ship_num"
                    }
                  }),
                  _c("span", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("PCS")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "20px" },
                      attrs: { "true-label": "1", "false-label": "2" },
                      model: {
                        value: _vm.keepStock.form.is_full_allot_ship,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.keepStock.form,
                            "is_full_allot_ship",
                            $$v
                          )
                        },
                        expression: "keepStock.form.is_full_allot_ship"
                      }
                    },
                    [_vm._v("配齐发货")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "配齐订单发货" } }, [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticClass: "_order_ids" },
                    _vm._l(_vm.keepStock.form.limit_ship_order_ids, function(
                      item,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "_order_ids_item" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.order_sn) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-plus _icon_plus",
                    on: { click: _vm.showOrderid }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "备注" },
                model: {
                  value: _vm.keepStock.form.stock_remark,
                  callback: function($$v) {
                    _vm.$set(_vm.keepStock.form, "stock_remark", $$v)
                  },
                  expression: "keepStock.form.stock_remark"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _vm.keepStock.action == 1
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveKeepStock }
                      },
                      [_vm._v("囤货")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "infor" },
                        on: {
                          click: function($event) {
                            _vm.keepStock.isShow = false
                          }
                        }
                      },
                      [_vm._v("\n          取消")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.keepStock.action == 2
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveKeepStock }
                      },
                      [_vm._v("保存")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.cancelKeepStock }
                      },
                      [_vm._v("取消囤货")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择订单号",
            visible: _vm.keepStock.order_id.isShow,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.keepStock.order_id, "isShow", $event)
            }
          }
        },
        [
          _c(
            "el-table",
            {
              ref: "orderSelectionTable",
              attrs: { data: _vm.keepStock.order_id.ids },
              on: { "selection-change": _vm.orderSelection }
            },
            [
              _c("el-table-column", { attrs: { type: "selection" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单id", prop: "order_id", align: "left" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单号", prop: "order_sn", align: "left" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.orderIdComfirm }
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "infor" }, on: { click: _vm.orderIdCancel } },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "尾货折销-导入打标ID完成发货",
            visible: _vm.isShowDialogTailOrder,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowDialogTailOrder = $event
            },
            close: _vm.handleDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formTailOrder",
              attrs: { model: _vm.formTailOrder, rules: _vm.formTailOrderRules }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户订单编号", prop: "order_id" } },
                [
                  _c("ys-input", {
                    model: {
                      value: _vm.formTailOrder.order_id,
                      callback: function($$v) {
                        _vm.$set(_vm.formTailOrder, "order_id", $$v)
                      },
                      expression: "formTailOrder.order_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "波次商品打标ID", prop: "excel" } },
                [
                  _c("input", {
                    ref: "input",
                    staticStyle: { display: "none" },
                    attrs: { type: "file" },
                    on: { change: _vm.handleFileChange }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleFileSelect }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.formTailOrder.excel ? "替换文件" : "添加文件"
                          ) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.formTailOrder.excel
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { margin: "0 8px" },
                          attrs: { closable: "" },
                          on: { close: _vm.handleFileRemove }
                        },
                        [_vm._v(_vm._s(_vm.formTailOrder.excel.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleTailOrderTempExport }
                    },
                    [_vm._v("\n          导出文件模版\n        ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingSubmitTail },
                  on: {
                    click: function($event) {
                      _vm.isShowDialogTailOrder = false
                    }
                  }
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingSubmitTail, type: "primary" },
                  on: { click: _vm.handleConfirmTailOrder }
                },
                [_vm._v("\n        提交\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("excel-import", { ref: "excelImport" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请选择打印的快递公司",
            visible: _vm.printNewVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.printNewVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.printNewForm } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "快递公司" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择快递公司" },
                      on: { change: _vm.getSenders },
                      model: {
                        value: _vm.printNewForm.express,
                        callback: function($$v) {
                          _vm.$set(_vm.printNewForm, "express", $$v)
                        },
                        expression: "printNewForm.express"
                      }
                    },
                    _vm._l(_vm.conditionData.express, function(express) {
                      return _c("el-option", {
                        key: express,
                        attrs: {
                          label: express,
                          value: express,
                          disabled: express === "物流"
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "网点" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择网点" },
                      model: {
                        value: _vm.printNewForm.sender_id,
                        callback: function($$v) {
                          _vm.$set(_vm.printNewForm, "sender_id", $$v)
                        },
                        expression: "printNewForm.sender_id"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "无", value: "0" } }),
                      _vm._v(" "),
                      _vm._l(_vm.senders, function(item) {
                        return _c("el-option", {
                          key: item.sender_id,
                          attrs: { label: item.sender, value: item.sender_id }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footeidr",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.printNewVisible = false
                      _vm.senders = []
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handlePrintNewExpress }
                },
                [_vm._v("\n        确 定（请确认打印机是否正常）")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46330c2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46330c2b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/WavePickingList.vue
// module id = null
// module chunks = 